export default "__VITE_ASSET__CTjgpr9R__"